/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import type {
  PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
  PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams,
  PostApiV1ExamRevisionLangBotexamlangidQuestion400,
  PostApiV1ExamRevisionLangBotexamlangidQuestion401,
  PostApiV1ExamRevisionLangBotexamlangidQuestion500,
} from "../../types/examRevisionController/PostApiV1ExamRevisionLangBotexamlangidQuestion.ts";
import { mutationOptions, useMutation } from "@tanstack/react-query";
import { postApiV1ExamRevisionLangBotexamlangidQuestion } from "../../clients/examRevisionController/postApiV1ExamRevisionLangBotexamlangidQuestion.ts";

export const postApiV1ExamRevisionLangBotexamlangidQuestionMutationKey = () =>
  [{ url: "/api/v1/exam/revision/lang/:botExamLangId/question" }] as const;

export type PostApiV1ExamRevisionLangBotexamlangidQuestionMutationKey =
  ReturnType<typeof postApiV1ExamRevisionLangBotexamlangidQuestionMutationKey>;

export function postApiV1ExamRevisionLangBotexamlangidQuestionMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey =
    postApiV1ExamRevisionLangBotexamlangidQuestionMutationKey();
  return mutationOptions<
    PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidQuestion400
      | PostApiV1ExamRevisionLangBotexamlangidQuestion401
      | PostApiV1ExamRevisionLangBotexamlangidQuestion500
    >,
    {
      botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ botExamLangId }) => {
      return postApiV1ExamRevisionLangBotexamlangidQuestion(
        botExamLangId,
        config,
      );
    },
  });
}

/**
 * @description Cria uma nova questão vazia para a lang de prova gerada por IA informada, replicando automaticamente para todos os demais idiomas cadastrados para a mesma prova. Cada questão é criada com 4 opções, sendo a primeira marcada como correta por padrão. **(Requer Authorization para autenticação)**
 * @summary Criar questão para todos os idiomas (Requer Authorization para autenticação)
 * {@link /api/v1/exam/revision/lang/:botExamLangId/question}
 */
export function usePostApiV1ExamRevisionLangBotexamlangidQuestion<TContext>(
  options: {
    mutation?: UseMutationOptions<
      PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionLangBotexamlangidQuestion400
        | PostApiV1ExamRevisionLangBotexamlangidQuestion401
        | PostApiV1ExamRevisionLangBotexamlangidQuestion500
      >,
      {
        botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    postApiV1ExamRevisionLangBotexamlangidQuestionMutationKey();

  const baseOptions =
    postApiV1ExamRevisionLangBotexamlangidQuestionMutationOptions(
      config,
    ) as UseMutationOptions<
      PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
      ResponseErrorConfig<
        | PostApiV1ExamRevisionLangBotexamlangidQuestion400
        | PostApiV1ExamRevisionLangBotexamlangidQuestion401
        | PostApiV1ExamRevisionLangBotexamlangidQuestion500
      >,
      {
        botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"];
      },
      TContext
    >;

  return useMutation<
    PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidQuestion400
      | PostApiV1ExamRevisionLangBotexamlangidQuestion401
      | PostApiV1ExamRevisionLangBotexamlangidQuestion500
    >,
    {
      botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    PostApiV1ExamRevisionLangBotexamlangidQuestionMutationResponse,
    ResponseErrorConfig<
      | PostApiV1ExamRevisionLangBotexamlangidQuestion400
      | PostApiV1ExamRevisionLangBotexamlangidQuestion401
      | PostApiV1ExamRevisionLangBotexamlangidQuestion500
    >,
    {
      botExamLangId: PostApiV1ExamRevisionLangBotexamlangidQuestionPathParams["botExamLangId"];
    },
    TContext
  >;
}
